'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = require('./icons/en-US');

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {Filters}\n  =1 {one filter}\n  ' + 'other {# filters}\n}'
  }
}, _enUS2.default, {
  Active: 'Active',
  Activate: 'Activate',
  Activated: 'Activated',
  Add: 'Add',
  add: 'add',
  Alerts: 'Alerts',
  All: 'All',
  ampm: 'ampm',
  Arc: 'Arc',
  AxisLabel: '{orientation} Axis',
  area: 'area',
  Bar: 'Bar',
  bar: 'bar',
  Blank: 'Blank',
  Box: 'Box',
  Carousel: 'Carousel',
  Category: 'Category',
  Circle: 'Circle',
  Chart: 'Chart',
  Children: 'Children',
  Clear: 'Clear',
  Cleared: 'Cleared',
  Close: 'Close',
  'Close Menu': 'Close Menu',
  Completed: 'Completed',
  'Connects With': 'Connects With',
  created: 'Created',
  Critical: 'Critical',
  'Currently Active': 'Currently Active',
  'Date Selector': 'Date Selector',
  'Date Time Icon': 'Open Date and Time Selector',
  day: 'day',
  Disabled: 'Disabled',
  Distribution: 'Distribution',
  Email: 'Email',
  'Enter Select': 'Press enter to select it',
  Error: 'Error',
  Filter: 'Filter',
  Footer: 'Footer',
  Grommet: 'Grommet',
  HotSpotsLabel: 'HotSpots: press arrow keys to interact with it',
  'GraphValues': 'Graph has {count} items. Highest is {highest}' + ' and smallest is {smallest}',
  hour: 'hour',
  'Grommet Logo': 'Grommet Logo',
  'Layer': 'Layer',
  List: 'List',
  line: 'line',
  'Loading': 'Loading',
  loginInvalidPassword: 'Please provide Username and Password.',
  'Log In': 'Log In',
  Logout: 'Logout',
  'Main Content': 'Main Content',
  Max: 'Max',
  Menu: 'Menu',
  Meter: 'Meter',
  Min: 'Min',
  minute: 'minute',
  model: 'Model',
  modified: 'Modified',
  monitor: 'monitor',
  month: 'month',
  'Multi Select': 'Multi Select',
  Name: 'Name',
  'Navigation Help': 'Use arrow keys to navigate',
  'Next Month': 'Next Month',
  'Next Slide': 'Next Slide',
  'No Relationship': 'No Relationship',
  'Notification': 'Notification',
  OK: 'OK',
  Open: 'Open',
  Parent: 'Parent',
  Parents: 'Parents',
  Parts: 'Parts',
  Part: 'Part',
  Password: 'Password',
  'Previous Month': 'Previous Month',
  'Previous Slide': 'Previous Slide',
  'Previous Tiles': 'Previous Tiles',
  'Remember me': 'Remember me',
  'Range Start': 'Range Start',
  'Range End': 'Range End',
  Resource: 'Resource',
  Running: 'Running',
  Search: 'Search',
  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
  second: 'second',
  'Select Icon': 'Open Select Drop',
  Selected: 'Selected',
  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
  'Skip to': 'Skip to',
  'Slide Number': 'Slide {slideNumber}',
  Sort: 'Sort',
  Spinning: 'Spinning',
  Spiral: 'Spiral',
  State: 'State',
  Status: 'Status',
  Subtract: 'Subtract',
  SunBurst: 'SunBurst',
  'Tab Contents': '{activeTitle} Tab Contents',
  Table: 'Table',
  Tasks: 'Tasks',
  Tiles: 'Tiles',
  Time: 'Time',
  Title: 'Title',
  Today: 'Today',
  Topology: 'Topology',
  Total: 'Total',
  Threshold: 'Threshold',
  Unknown: 'Unknown',
  Username: 'Username',
  uri: 'URI',
  Value: 'Value',
  Warning: 'Warning',
  year: 'year'
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/en-US.js
// module id = 126
// module chunks = 0